// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"puppiesSection_wrapper__bw_6b","heading":"puppiesSection_heading__FZCLH","content":"puppiesSection_content__UESuj"};